export const sidebar = {
  assetManagement: '資產管理',
  referenceInformation: '參考資料',
  report: '報告表',
  systemManagement: '系統管理',
  searchAssets: '搜尋資產',
}
